import { render } from "./LinkContainer.vue?vue&type=template&id=160059d3"
const script = {}

import "./LinkContainer.vue?vue&type=style&index=0&id=160059d3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__